import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { CmsApiProvider } from '@apis/credential-management-service/cms-api-provider';
import { SoarApiProvider } from '@apis/soar-active-response/soar-api-provider';

const ActiveResponseNewIntegration = lazy(
  () => import('./active-response-new-integration.page'),
);

const ActiveResponseInstanceId = lazy(
  () => import('./active-response-instance-id.page'),
);

export const ActiveResponseRoutes = () => {
  return (
    <SoarApiProvider>
      <CmsApiProvider>
        <Routes>
          <Route path="/new" element={<ActiveResponseNewIntegration />} />
          <Route
            path="/view/:instanceId"
            element={<ActiveResponseInstanceId />}
          />
        </Routes>
      </CmsApiProvider>
    </SoarApiProvider>
  );
};
